export default {
  section: 'Market Map',
  config: {
    standalone: true,
    title: 'Approve new map request',
  },
};
